import { render, staticRenderFns } from "./OldForeignCurrencySavings.vue?vue&type=template&id=1f755644&scoped=true&"
import script from "./OldForeignCurrencySavings.vue?vue&type=script&lang=js&"
export * from "./OldForeignCurrencySavings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f755644",
  null
  
)

export default component.exports